import React from 'react';

const Imprint = () => {
  return (
    <div className="min-h-screen bg-[#f4f4f4] py-12 md:py-20 px-6">
      <div className="max-w-4xl mx-auto bg-white border-[4px] border-black p-8 md:p-16 brutal-shadow text-left">
        <header className="border-b-[4px] border-black pb-8 mb-12">
          <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter leading-none mb-4 text-black">
            Imprint
          </h1>
          <div className="inline-block bg-black text-white px-4 py-1 font-black uppercase text-sm">
            Legal Notice
          </div>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 font-medium text-lg">
          {/* Left Column */}
          <div className="space-y-10">
            <section>
              <h2 className="text-xs uppercase tracking-[0.2em] text-gray-500 font-black mb-2">Responsible for Content</h2>
              <p className="text-3xl font-black uppercase leading-none text-black">Mathias Deppe</p>
            </section>

            <section>
              <h2 className="text-xs uppercase tracking-[0.2em] text-gray-500 font-black mb-2">Address</h2>
              <p className="leading-relaxed font-bold">
                Nemesi Valls 42<br />
                08210 Barberà del Vallès<br />
                Barcelona, Spain
              </p>
            </section>

            <section>
              <h2 className="text-xs uppercase tracking-[0.2em] text-gray-500 font-black mb-2">Contact & Support</h2>
              <div className="space-y-2">
                <p className="flex flex-col">
                  <span className="text-sm font-black uppercase text-gray-400">Email</span>
                  <a href="mailto:support@etera.store" className="text-blue-600 font-black hover:underline decoration-2 underline-offset-4">
                    support@etera.store
                  </a>
                </p>
                <p className="flex flex-col">
                  <span className="text-sm font-black uppercase text-gray-400">Phone</span>
                  <span className="font-black">+34 623780182</span>
                </p>
              </div>
            </section>
          </div>

          {/* Right Column */}
          <div className="space-y-10">
            <section>
              <h2 className="text-xs uppercase tracking-[0.2em] text-gray-500 font-black mb-2">Tax Identification</h2>
              <div className="p-4 bg-yellow-300 border-2 border-black inline-block">
                <p className="text-xs font-black uppercase mb-1">VAT/Tax ID (NIF/NIE)</p>
                <p className="text-xl font-black">Y8187448Z</p>
              </div>
            </section>

            <section>
              <h2 className="text-xs uppercase tracking-[0.2em] text-gray-500 font-black mb-2">About ETERA</h2>
              <p className="text-base font-bold italic text-gray-700">
                ETERA is a digital product service focused on permanent link infrastructure. We provide the tools for businesses to own their physical-to-digital bridges without recurring subscriptions.
              </p>
            </section>

            <section className="p-6 bg-[#f9f9f9] border-2 border-black border-dashed">
              <h2 className="text-xs uppercase tracking-[0.2em] text-gray-500 font-black mb-3">EU Dispute Resolution</h2>
              <p className="text-sm font-bold leading-relaxed">
                The European Commission provides a platform for online dispute resolution (ODR): 
                <a 
                  href="https://ec.europa.eu/consumers/odr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block mt-1 text-blue-600 hover:underline break-all"
                >
                  https://ec.europa.eu/consumers/odr
                </a>
              </p>
              <p className="text-sm font-bold mt-4 text-gray-500">
                We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board.
              </p>
            </section>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t-4 border-black text-center">
          <p className="text-xs font-black uppercase tracking-[0.3em] text-gray-400">
            ETERA.STORE — BUILT TO LAST.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Imprint;